import { Routes, Route, useLocation } from 'react-router-dom'
import { Suspense, lazy, useEffect } from 'react'
import { useQuery } from 'react-query'
import Layout from './components/Layout'
import LoadingSpinner from './components/ui/LoadingSpinner'
import ScrollToTop from './components/ScrollToTop'
import { companyService } from './services/company'
import { getMediaUrl } from './services/api'
import { LanguageProvider } from './contexts/LanguageContext'
import './i18n/config'

// Lazy load pages for better performance
const Home = lazy(() => import('./pages/Home'))
const About = lazy(() => import('./pages/About'))
const Services = lazy(() => import('./pages/Services'))
const ServiceDetail = lazy(() => import('./pages/ServiceDetail'))
const Projects = lazy(() => import('./pages/Projects'))
const Blog = lazy(() => import('./pages/Blog'))
const BlogPost = lazy(() => import('./pages/BlogPost'))
const Contact = lazy(() => import('./pages/Contact'))
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'))
const TermsOfService = lazy(() => import('./pages/TermsOfService'))
const NotFound = lazy(() => import('./pages/NotFound'))

function App() {
  const location = useLocation()
  
  // Fetch company info for favicon and meta tags
  const { data: companyInfo } = useQuery('companyInfo', companyService.getCompanyInfo, {
    staleTime: 5 * 60 * 1000, // 5 minutes
  })

  // Update favicon dynamically
  useEffect(() => {
    if (companyInfo?.favicon) {
      const favicon = document.querySelector('link[rel="icon"]') as HTMLLinkElement
      if (favicon) {
        favicon.href = getMediaUrl(companyInfo.favicon) || ''
      }
    }
  }, [companyInfo])

  return (
    <LanguageProvider>
      <ScrollToTop />
      <Layout>
        <Suspense fallback={<LoadingSpinner />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/hakkimizda" element={<About />} />
            <Route path="/hizmetler" element={<Services />} />
            <Route path="/hizmetler/:slug" element={<ServiceDetail />} />
            <Route path="/projeler" element={<Projects />} />
            <Route path="/projeler/:slug" element={<Projects />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost key={location.pathname} />} />
            <Route path="/iletisim" element={<Contact />} />
            <Route path="/gizlilik-politikasi" element={<PrivacyPolicy />} />
            <Route path="/kullanim-sartlari" element={<TermsOfService />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </Layout>
    </LanguageProvider>
  )
}

export default App
